import React, { useEffect, useState } from 'react';
import {ReactComponent as CloserIcon} from "../../assets/images/close-square2.svg";
import "./ProdRedirection.scss"

const ProdRedirection:React.FC = ()=>{

    const [show,setShow]=useState(true)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const redirectToProd = ()=>{
        window.open("https://flow.rupeezy.in/login", '_blank')?.focus()
    }
    const close = ()=>{
        setShow(false)
    }

    if(show && !isMobile){
        return(
            <React.Fragment>
                <div className='top'>
                    <div className='Header'>This is a beta version of the trading platform. Some features may not work properly.</div>
                    <div className='center_btn'>
                        <div className='redirect_btn c-pointer' onClick={redirectToProd}>Visit main platform</div>
                        <div className='c-pointer' style={{"paddingLeft":"120px"}} onClick={close}><CloserIcon/></div>
                    </div>
                </div>
            </React.Fragment>
        )
    }else{
        return(
            <></>
        )
    }
}

export default ProdRedirection